import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Category } from 'src/models/DTO/categeroies/category';
import { CategoriesService } from 'src/services/request/categories/categories.service';
import { HistoryService } from 'src/services/state/history/history.service';

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.css']
})
export class RootComponent extends HistoryBaseComponent implements OnInit {

  private _category?: Category = { data: [] };
  private _categoryOrder = [
    "Авто и ремонт",
    "Дом и градина",
    "Мода",
    "Храна",
    "Забавления и свободно време",
    "Техника",
    "Здраве и красота",
    "За децата"
  ];
  constructor(
    private categoriesService: CategoriesService,
    private router: Router,
    protected location: Location,
    protected historyService: HistoryService

  ) {
    super(location, historyService);
    this._pageTitle = '';
    this.categoriesService.getAllRootCategories().subscribe((response) => {
      this._categoryOrder.forEach(orderedItem => {
        response.data.forEach(category => {
          if (category.name == orderedItem) {
            this._category?.data.push(category);
          }
        });
      });
    })
  }

  ngOnInit(): void {
  }

  get categories() {
    return this._category?.data;
  }

  getCategoryImageById(id: number) {
    return "/assets/images/categories/product-category-" + id.toString() + '.png';
  }

  goToSub(category: any) {
    this.router.navigate(['/categories/sub/' + category.uuid + '/' + category.name]);
  }
}
